const trimSlashes = (value) => String(value || "").replace(/^\/+|\/+$/g, "");
const trimTrailingSlashes = (value) => String(value || "").replace(/\/+$/g, "");

const defaultPublicBase =
  process.env.NODE_ENV === "development" ? "/" : "/is/onlinejeju43/";

export const publicBaseUrl = () => {
  const base = process.env.BASE_URL || process.env.VUE_APP_BASE_URL || defaultPublicBase;
  return base.endsWith("/") ? base : `${base}/`;
};

export const publicAssetUrl = (path = "") => {
  const base = publicBaseUrl();
  const normalizedBase = base.endsWith("/") ? base : `${base}/`;
  const normalizedPath = trimSlashes(path);
  const suffix = String(path || "").endsWith("/") && normalizedPath ? "/" : "";
  return `${normalizedBase}${normalizedPath}${suffix}`;
};

export const apiUrl = (path = "") => {
  const host = process.env.VUE_APP_API_HOST || "/api/";
  return `${trimTrailingSlashes(host)}/${trimSlashes(path)}`;
};

export const apiAssetUrl = (path = "") => {
  const value = String(path || "");

  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  const host = trimTrailingSlashes(process.env.VUE_APP_API_HOST || "/api/");
  const normalizedValue = `/${trimSlashes(value)}`;

  if (host.startsWith("/") && (normalizedValue === host || normalizedValue.startsWith(`${host}/`))) {
    return normalizedValue;
  }

  return apiUrl(value);
};
